<template>
  <router-view />
</template>

<script>
import storeMixin, {
  unRegisterMixin,
} from '@quisit/mipe-utils/mixins/storeGenerator';
import storeModuleNames from '@/utils/constants/storeModuleNames.js';

export default {
  name: 'WrapperContractDocumentConfiguration',
  mixins: [unRegisterMixin, storeMixin],
  data: () => ({
    moduleName:
      storeModuleNames.ProviderContractDocumentConfigurationManagementModuleName,
  }),
};
</script>
